import { matchPath } from 'react-router';

import { PageTags, Params } from './types';

class OrganizationPageTags extends PageTags {
  static get({ pathname, exact }: Params) {
    let currentPage = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const [path] of Object.entries(this.container)) {
      const currentRoutePath = matchPath(pathname, { path, exact });
      if (currentRoutePath) {
        currentPage = path;
        break;
      }
    }

    if (this.container[currentPage]) {
      return this.container[currentPage];
    }
    return undefined;
  }

  static get container(): {[key: string]: string[]} {
    return {
      '/dashboard/admin/organizations': this.organizations,
      '/dashboard/admin/organizations/:id/account': this.account,
      '/dashboard/admin/organizations/:id/team': this.team,
      '/dashboard/admin/organizations/:id/billing': this.billing,
      '/dashboard/user/organizations/:id/account': this.account,
      '/dashboard/user/organizations/:id/team': this.team,
      '/dashboard/user/organizations/:id/billing': this.billing,
    };
  }

  static get organizations() {
    return [
      'tag:organization',
      'tag:list',
    ];
  }

  static get account() {
    return [
      'tag:organization',
      'tag:account',
      'tag:detail',
    ];
  }

  static get team() {
    return [
      'tag:organization',
      'tag:team',
      'tag:detail',
    ];
  }

  static get billing() {
    return [
      'tag:organization',
      'tag:billing',
      'tag:detail',
    ];
  }
}


export default OrganizationPageTags;
